import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-servicing-request-form',
  templateUrl: 'servicing-request-form.component.html',
  styleUrls: ['servicing-request-form.component.scss']
})
export class ServicingRequestFormComponent implements OnInit {

  @Input() formType: string = 'address'; // What form?

  constructor() { }

  ngOnInit() {
  }

}
